export const BASE_URL = "/ecom_api";

